import React from "react";
import { STATE_ART } from "./desiAssets";
import "./desi.css";

/**
 * Frame shared by every state game: state title banner, Time / Score / Skip
 * pills and the state characters on either side of the play area.
 */
export default function GameShell({
  gameKey,
  timeLabel,
  score,
  onSkip,
  skipDisabled,
  children,
}) {
  const art = STATE_ART[gameKey];

  return (
    <div className="desi-page">
      <img className="desi-title" src={art.title} alt="" draggable={false} />
      <img className="desi-subtitle" src={art.text} alt="" draggable={false} />

      <div className="desi-scoreboard">
        <div className="desi-pill desi-pill--time" aria-live="off">
          Time: {timeLabel}
        </div>
        <div className="desi-scoreboard__right">
          <div className="desi-pill desi-pill--score">Score: {score}</div>
          <button
            type="button"
            className="desi-pill desi-pill--skip"
            disabled={skipDisabled}
            onClick={onSkip}
          >
            Skip
          </button>
        </div>
      </div>

      <div className="desi-stage">
        <aside className={`desi-side${art.left ? "" : " desi-side--empty"}`} aria-hidden="true">
          {art.left ? <img src={art.left} alt="" draggable={false} /> : null}
        </aside>
        <main className="desi-main">{children}</main>
        <aside className={`desi-side${art.right ? "" : " desi-side--empty"}`} aria-hidden="true">
          {art.right ? <img src={art.right} alt="" draggable={false} /> : null}
        </aside>
      </div>
    </div>
  );
}
